import { CompanyInfo } from "./company-info";
import { CompanyContact } from "./company-contact";
import { CompanyType } from "./company-type";
import { CompanyKey } from "./company-key";

export class Company {
  private companyKey: CompanyKey;
  private unit: string;
  private companyType: CompanyType;
  private headOfficeFiscalNumber: string;
  private fiscalNumber: string;
  private stateRegistration: string;
  private municipalRegistration: string;
  private corporateName: string;
  private tradingName: string;
  private companyInfo: CompanyInfo;
  private companyContacts: Array<CompanyContact>;
  private isActive: boolean;

  static fromObject(obj: any): Company {
    const company = new Company();
    company.setFiscalNumber(obj.FiscalNumber);
    return company;
  }

  setCompanyKey(value: CompanyKey): void {
    this.companyKey = value;
  }

  getCompanyKey(): CompanyKey {
    return this.companyKey;
  }

  getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  getHeadOfficeFiscalNumber(): string {
    return this.headOfficeFiscalNumber;
  }

  setHeadOfficeFiscalNumber(value: string): void {
    this.headOfficeFiscalNumber = value;
  }

  getCompanyInfo(): CompanyInfo {
    return this.companyInfo;
  }

  setCompanyInfo(value: CompanyInfo): void {
    this.companyInfo = value;
  }

  getCompanyContacts(): Array<CompanyContact> {
    return this.companyContacts;
  }

  setCompanyContacts(value: Array<CompanyContact>): void {
    this.companyContacts = value;
  }

  setCorporateName(value: string): void {
    this.corporateName = value;
  }

  getCorporateName(): string {
    return this.corporateName;
  }

  setTradingName(value: string): void {
    this.tradingName = value;
  }

  getTradingName(): string {
    return this.tradingName;
  }

  setCompanyType(value: CompanyType): void {
    this.companyType = value;
  }

  getCompanyType(): CompanyType {
    return this.companyType;
  }

  setUnit(value: string): void {
    this.unit = value;
  }

  getUnit(): string {
    return this.unit;
  }

  setStateRegistration(value: string): void {
    this.stateRegistration = value;
  }

  getStateRegistration(): string {
    return this.stateRegistration;
  }

  setMunicipalRegistration(value: string): void {
    this.municipalRegistration = value;
  }

  getMunicipalRegistration(): string {
    return this.municipalRegistration;
  }

  setIsActive(value: boolean): void {
    this.isActive = value;
  }

  getIsActive(): boolean {
    return this.isActive;
  }
}
